import {
  BanIcon,
  CircleCheckIcon,
  ClockAlertIcon,
  GlobeLockIcon,
  HourglassIcon,
  KeyRoundIcon,
  MailXIcon,
  RectangleEllipsisIcon,
  ShieldAlertIcon,
  ShieldXIcon,
  TimerOffIcon,
  TriangleAlertIcon,
  UserRoundCheckIcon,
  UserRoundXIcon,
  WrenchIcon,
  type LucideIcon,
} from 'lucide-react';

import { CHIP_COLORS, type ChipColor } from '@/components/ui/status-chip';
import { isKnownSignInProblem, type SignInProblem } from '@/lib/guest-auth/sign-in-methods';

export interface GateStyle {
  icon: LucideIcon;
  color: ChipColor;
}

/** Shared by the transcript, the confirmation card and the back office. `action` is the neutral
 *  look of an action itself, with the icon for one whose trail has none. */
export const GATE_STYLES = {
  signInCompleted: { icon: UserRoundCheckIcon, color: CHIP_COLORS.green },
  signInNotCompleted: { icon: UserRoundXIcon, color: CHIP_COLORS.red },
  signInProblem: { icon: KeyRoundIcon, color: CHIP_COLORS.amber },
  actionConfirmed: { icon: CircleCheckIcon, color: CHIP_COLORS.green },
  actionDeclined: { icon: BanIcon, color: CHIP_COLORS.red },
  actionSkipped: { icon: HourglassIcon, color: CHIP_COLORS.neutral },
  action: { icon: WrenchIcon, color: CHIP_COLORS.neutral },
} as const satisfies Record<string, GateStyle>;

const SIGN_IN_PROBLEM_ICONS: Readonly<Record<SignInProblem, LucideIcon>> = {
  wrongCode: RectangleEllipsisIcon,
  expired: TimerOffIcon,
  tooMany: ShieldAlertIcon,
  sendFailed: MailXIcon,
  error: TriangleAlertIcon,
  unavailable: GlobeLockIcon,
  rejected: ShieldXIcon,
  sessionExpired: ClockAlertIcon,
};

export function signInProblemStyle(result: string): GateStyle {
  return {
    ...GATE_STYLES.signInProblem,
    ...(isKnownSignInProblem(result) && { icon: SIGN_IN_PROBLEM_ICONS[result] }),
  };
}
